import * as i0 from "@angular/core";
export class EncoderService {
    encode(data) {
        return btoa(JSON.stringify(data));
    }
    decode(data) {
        return JSON.parse(atob(data));
    }
}
EncoderService.ngInjectableDef = i0.defineInjectable({ factory: function EncoderService_Factory() { return new EncoderService(); }, token: EncoderService, providedIn: "root" });
